import Layout from '@/page/layout/home'
import LayoutNoFooter from '@/page/layout/index'
import bizRouters from './biz/index'

export default [
    ...bizRouters,
    {
        path: '/index',
        name: 'home',
        component: Layout,
        redirect: '/index/index',
        children: [{
            path: 'index',
            name: 'index',
            component: () => import(/* webpackChunkName: "views" */ '@/views/index/index.vue'),
            meta: {
                title: '首页',
                isAuth:true,
                dingConfig:true
            }
        }, {
            path: 'my',
            name: 'my',
            component: () => import(/* webpackChunkName: "views" */ '@/views/my/index.vue'),
            meta: {
                title: '我的',
                keepAlive: true,
                isAuth:true,
                dingConfig:true
            }
        }]
    }
]
